module.exports = __webpack_public_path__ + "static/media/animated-1.13bad28e.gif";